import Pistachios from "./Pistachios";

export default Pistachios;